var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?sourceMap!../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7b6fd5e4\",\"scoped\":false,\"hasInlineConfig\":true}!stylus-loader!../vue-loader/lib/selector?type=styles&index=0!./auto-textarea.vue")
}
var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./auto-textarea.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7b6fd5e4\",\"hasScoped\":false}!../vue-loader/lib/selector?type=template&index=0!./auto-textarea.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/vercel/path0/node_modules/auto-textarea/auto-textarea.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] auto-textarea.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b6fd5e4", Component.options)
  } else {
    hotAPI.reload("data-v-7b6fd5e4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/auto-textarea/auto-textarea.vue
// module id = 209
// module chunks = 0